export class ListDataCatalogJoinabilityResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entries",
            "baseName": "entries",
            "type": "Array<DataCatalogJoinabilityEntry>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDataCatalogJoinabilityResponse.attributeTypeMap;
    }
    constructor() {
    }
}
